import { EYES_CORPUS, itemsByDifficulty, } from './corpus';
import { timing, variantForLevel } from './params';
const sessionMemory = { shown: new Set() };
export function resetSessionMemory() {
    sessionMemory.shown.clear();
}
function pickItemForDifficulty(difficulty) {
    const tiers = [difficulty, difficulty - 1, difficulty + 1, difficulty - 2, difficulty + 2];
    for (const t of tiers) {
        const pool = itemsByDifficulty(t).filter((i) => !sessionMemory.shown.has(i.id));
        if (pool.length > 0) {
            const choice = pool[Math.floor(Math.random() * pool.length)];
            sessionMemory.shown.add(choice.id);
            return choice;
        }
    }
    // Fallback ultime : reset et reprends au tier demandé.
    sessionMemory.shown.clear();
    const all = itemsByDifficulty(difficulty);
    if (all.length === 0) {
        // Banque vide pour ce tier, prends n'importe quel item.
        const fallback = EYES_CORPUS[Math.floor(Math.random() * EYES_CORPUS.length)];
        sessionMemory.shown.add(fallback.id);
        return fallback;
    }
    const choice = all[Math.floor(Math.random() * all.length)];
    sessionMemory.shown.add(choice.id);
    return choice;
}
export function makeStimulus(trialIdx, difficulty, _level) {
    const tier = Math.max(1, Math.min(5, Math.round(difficulty)));
    const item = pickItemForDifficulty(tier);
    return {
        trialIdx,
        difficulty: tier,
        item,
    };
}
export function createEyesTestToMAdapter(level = 1) {
    let state = {
        subPhase: 'idle',
        stim: null,
        feedback: null,
        pickedIdx: null,
        level,
        variant: variantForLevel(level),
    };
    const listeners = new Set();
    let resolver = null;
    let rejecter = null;
    let trialStart = 0;
    const timers = [];
    function clearTimers() {
        while (timers.length > 0) {
            const t = timers.pop();
            if (t !== undefined)
                clearTimeout(t);
        }
    }
    function update(patch) {
        state = { ...state, ...patch };
        for (const l of listeners) {
            try {
                l(state);
            }
            catch {
                /* ignored */
            }
        }
    }
    return {
        mount() {
            // Idempotent — rendu déclaratif côté React.
        },
        unmount() {
            clearTimers();
            listeners.clear();
            if (rejecter) {
                rejecter(new Error('unmount'));
                rejecter = null;
                resolver = null;
            }
        },
        presentStimulus(stim) {
            clearTimers();
            return new Promise((resolve, reject) => {
                resolver = resolve;
                rejecter = reject;
                update({
                    subPhase: 'reading',
                    stim,
                    feedback: null,
                    pickedIdx: null,
                });
                timers.push(setTimeout(() => {
                    update({ subPhase: 'awaiting_response' });
                    trialStart = Date.now();
                }, timing.readingMs));
            });
        },
        async showFeedback(correct) {
            update({
                subPhase: 'feedback',
                feedback: correct ? 'correct' : 'incorrect',
            });
            await new Promise((resolve) => {
                timers.push(setTimeout(() => {
                    update({ subPhase: 'iti' });
                    resolve();
                }, timing.feedbackMs));
            });
        },
        pause() {
            // Sprint 0.5 : no-op.
        },
        resume() {
            // Sprint 0.5 : no-op.
        },
        abort() {
            clearTimers();
            if (rejecter) {
                rejecter(new Error('aborted'));
                rejecter = null;
                resolver = null;
            }
        },
        getState() {
            return state;
        },
        subscribe(listener) {
            listeners.add(listener);
            listener(state);
            return () => {
                listeners.delete(listener);
            };
        },
        handlePick(pickedIdx) {
            if (state.subPhase !== 'awaiting_response')
                return;
            const stim = state.stim;
            if (!stim)
                return;
            const correctIdx = stim.item.correctIdx;
            const correct = pickedIdx === correctIdx;
            const rt = Date.now() - trialStart;
            const resp = {
                pickedIdx,
                correctIdx,
                correct,
                reactionTimeMs: rt,
            };
            update({ pickedIdx });
            if (resolver) {
                const r = resolver;
                resolver = null;
                rejecter = null;
                r(resp);
            }
        },
        setLevel(newLevel) {
            const v = variantForLevel(newLevel);
            update({ level: newLevel, variant: v });
        },
        resetSession() {
            resetSessionMemory();
        },
    };
}
//# sourceMappingURL=adapter.js.map